import FetchInterceptor from "configs/FetchInterceptor";

class WarehouseServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/warehouses/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/warehouses/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async getByIds(requestBody) {
    const apiUrl = "/core/v1/warehouses/get/data";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/warehouses/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/warehouses/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async checkPrimary(requestBody) {
    const apiUrl = "/core/v1/warehouses/primary";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default WarehouseServices;
